import { render, staticRenderFns } from "./UserSubscription.vue?vue&type=template&id=6a045ec5&"
import script from "./UserSubscription.vue?vue&type=script&lang=js&"
export * from "./UserSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports